export default "__VITE_ASSET__Cb98Dd8t__"